import { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function Captcha({ handleChange, error }) {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const captchaRef = useRef(null);

  function onChange(value) {
    handleChange(value);
  }
  return (
    <div className="div-captcha">
      <div className="row-captcha">
        <div>
          <ReCAPTCHA
            sitekey={siteKey}
            render="explicit"
            ref={captchaRef}
            onChange={onChange}
            hl="sl"
          />
          <span className="required">
            {error !== "" && <p>{error}</p>}
          </span>
        </div>
      </div>
    </div>
  );
}
